import React from 'react'
import { SubpageWrapper } from '../subpage-wrapper'
import Subpage from '../subpage'
import './baking.css'

export const Baking = () => {
    return <SubpageWrapper><Subpage>
        <div className='sourdough-guide'>

        <h3 className="title">SOURDOUGH BREAD GUIDE</h3>
        <div>william hayward</div>

        <p>--------</p>

        <h4>Introduction</h4>
        <p>
            By no means is this “my recipe”, I’m simply writing it down, along with some tips I’ve learned along the way. My mom taught me how to make my first loaf, and her friend taught her. Hopefully someday, you’ll teach someone else!
            As you embark on your sourdough journey, it may take some time to get consistent results. As you aim to nail down your recipe, I suggest adjusting one variable at a time. Changing too many at once might leave you wondering which variable gave you changes.
        </p>

        <p>--------</p>
        <p>yeilds: 2 sourdough loaves</p>
        <h4>Ingredients</h4>
        <ul>
            <li>
                600g Bread flour, use the high protein kind (I use king arthur or bobs)
            </li>
            <li>
                300g All purpose flour
            </li>
            <li>
                100g Whole wheat flour
            </li>
            <li>
                20g fine sea salt
            </li>
            <li>
                800g water
            </li>
        </ul>
        <h4>Materials</h4>
        <ul>
            <li>An active sourdough starter
            </li>
            <li>
                Kitchen scale
            </li>
            <li>
                Large (ideally clear glass) mixing bowl

            </li>
            <li>
                Banneton or Medium sized bowl + clean dishcloth
            </li>
            </ul>

        <h4>Optional Materials</h4>
        <ul>
        <li>
            Bench knife for shaping
        </li>
        <li>
        Banneton proofing basket
        </li>
        <li>Dutch oven
        </li>
        <li>
            Razor blade
        </li>
        <li>
            Thermometer (this is how I unlocked consistent results)
        </li>
        </ul>

        <h4>Temperature</h4>
        <p>Probably the most important variable. The warmer your kitchen, the faster your bread will ferment (and same with your starter). Time and temperature work in opposite directions. As one increases, you’ll need to decrease the other. </p>


        <h4>Your starter</h4>
        <p>To feed your starter, combine:</p>
        <ul>
            <li>50g starter</li>
            <li>100g water</li>
            <li>100g flour</li>
        </ul>
        <p>Your starter is ready to use when it has doubled, and is light & airy. If your starter floats in water, it is probably ready to use!</p>
        <p>Doubling may take between 4-12 hours depending on the temperature in your home. If you find your starter is peaking too quickly for your baking schedule, you can use 40g of starter and 130g water with 130g flour.</p>
        <p>If storing starter on the counter, feed it once per day.</p>


        <p>--------</p>
        <h4>Baking Schedule</h4>
        <h4>Day 1</h4>
        <div className="sourdough-day">
        <p>Feed your starter before going to sleep.</p>
        </div>


        <h4>Day 2</h4>
        <div className="sourdough-day">
        <h5>Mix your bread</h5>
        <p>Mix the following ingredients in a large mixing bowl. I usually double everything and make two loaves
        </p>
        <ul>
            <li>800g warm water</li>
            <li>200g active, bubbly, floaty starter. After adding the starter to the water, I like to whisk them together before adding the dry ingredients</li>
            <li>1000g flour</li>
            <li>20g salt</li>
        </ul>

        <p>Mix until well combined. You can use a big spoon or fork or your hands. A mixer isn’t necessary.</p>
        <p>Place plastic or a compost bag over the bowl to keep the dough from drying out during fermentation.</p>

        <h5>Bulk fermentation</h5>
        <p>This will take approximately 4-6 hours at 80 degrees fahrenheit. At 80 degrees, you are looking for the bread to rise 30-50%. At 70 degrees fahrenheit, this will take approximately 6-12 hours. At 70 degrees, you are looking for the bread to rise about 75%. This is why I recommend using a thermometer. I usually proof my bread in the oven with the light turned on. This will keep your oven warm, which you can use to proof your bread.</p>

        <p>For the curious, <a href="https://thesourdoughjourney.com/the-mystery-of-percentage-rise-in-bulk-fermentation/" target="_blank">this</a> blog post is very informative about temperature and rise percentage.</p>

        <p>Every 30 minutes for the first 2 hours, stretch and fold your dough. The first time, you can do about 10-15 stretches and folds. Each successive time, 4 is plenty. You never want your dough to rip. The goal here is to build up dough strength.</p>

        <h5>Pre-shaping</h5>
        <p>30 minutes before bulk fermentation is finished, place your dough onto a clean, lightly floured surface and divide the dough. Form into rough balls, and let sit for 30 minutes.</p>

        <h5>Shaping</h5>
        <p>After your dough has finished rising, place your dough onto a clean, lightly floured surface. Gently stretch the dough into a rectangle and fold the corners in to form a tight ball. There are many different shaping techniques, and I suggest just googling “how to shape sourdough loaf”. The trick is to use clean hands and not too much flour. You want the dough to stick to itself. A bench knife really helps here.</p>
        <p>After your dough is nicely shaped, lie a tea cloth over your medium bowl and dust it with four. Rice flour is a cheat code here, it will make your tea cloth non-stick.</p>
        <p>Place your dough into the tea cloth seam side up.</p>
        <p>Fold the cloth over your bowl and place in the fridge. If you’re using a banneton with no cloth, I put the whole thing into a compost bag to keep it from drying out.</p>

        <h5>Cold retard</h5>
        <p>Leave the bread in the fridge for 12-48 hours. This is when the sour flavor develops.</p>
        </div>

        <h4>Day 3:</h4>
        <div className="sourdough-day">
        <p>Preheat your oven with a dutch oven inside (with the lid on) at 450 for 30 minutes.</p>
        <p>Take out the dutch oven and gently place your bread inside, seam side down. Careful not to burn yourself!</p>
        <p>Score your bread with a sharp knife or a razor blade and put the lid back on the dutch oven.</p>
        <p>After 25 minutes, remove the lid from the dutch oven.</p>
        <p>Bake for another 10-15 minutes, until the bread is nice and dark brown.</p>
        <p>Enjoy!!!</p>
        </div>


        <h4>Notes</h4>
        <ul>
        <li>This recipe uses 400g water (80% hydration), which is quite high! If this is your first time, I suggest using 300-350g until you get the hang of things. It will make the whole process a little more forgiving!</li>
        <li>Currently, the Kirkland Organic All-Purpose flour is high quality flour. You can use this in place of BOTH the bread flour and All-purpose flour that this recipe calls for.</li>
        </ul>

        </div>
        </Subpage></SubpageWrapper>
}

export default Baking
